import React from 'react';
import { Box } from '@mui/material';
import { GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { GridToolbarExport, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid-pro';


export function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 1,
                m: 2,
                width: '100%',
                flex: 1,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}


export function ColumnsFilterExportToolbar() {
    return (
      <GridToolbarContainer style={{paddingTop: '10px', display: 'flex', flex : 1, justifyContent : 'space-between'}}>
        <Box sx={{ flex : 1 }}>
        <GridToolbarColumnsButton style={{color: '#434F69'}} />
        <GridToolbarFilterButton style={{color: '#434F69'}}/>
        <GridToolbarExport style={{color: '#434F69'}}/>
        </Box>        
        <GridToolbarQuickFilter placeholder='Search Bundle Title'/>        
      </GridToolbarContainer>
    );
}
